module.exports = __webpack_public_path__ + "static/media/silver_evoucher.92a6ae83.png";